import directionStraightRight from '@iconify/icons-carbon/direction-straight-right';
import { Box, Button, Typography } from '@mui/material';
import Image from 'next/legacy/image';
import { i18n } from 'next-i18next';
import { useState } from 'react';

import { Iconify } from '@larvitu/shared/mui/ui-components';
import { Link } from '@larvitu/shared/next/mui';

import type { BoxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import type { FC } from 'react';

interface ServiceCardProps extends BoxProps {
  data?: {
    title?: string;
    content?: string;
    href?: string;
    icon?: { src: string; alt: string; title: string };
    readMore?: string;
  };
}

// service card creation
const defaultIcon = { src: '', alt: '', title: '' };

export const ServiceCard: FC<ServiceCardProps> = ({
  data ,
  ...props
}) => {
if (!data) return null;
  const {
    icon = defaultIcon,
      title = '',
      href = '/',
      content = '',
      readMore = i18n?.t('read-more', { ns: 'common' }),
  } = data;

  const [isMouseOver, setIsMouseOver] = useState(false);
  const handleMouseEnter = (): void => {
    setIsMouseOver(true);
  };
  const handleMouseLeave = (): void => {
    setIsMouseOver(false);
  };
  const maxWords = 12;

  return (
    // <links color="text.primary" >
    <Box
      component={Link}
      href={href}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      display="flex"
      flexDirection="column"
      justifyContent={{ sm: 'center', md: 'space-evenly' }}
      py={2}
      px={3}
      sx={(theme: Theme): SystemStyleObject<Theme> => ({
        boxSizing: 'content-box',
        height: { md: 350, lg: 450 },
        transition: 'all 200ms ease-in-out',
        background: theme.palette.background.default,
        boxShadow: 3,
        '&:hover': {
          boxShadow: 20,
          textDecoration: 'none',
        },
      })}
      {...props}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Image
          src={icon.src}
          alt={icon.alt}
          title={icon.title}
          width={32}
          height={32}
        />
        <Typography fontWeight="bold" variant="h3">
          {title}
        </Typography>
      </Box>

      <Typography color="text.secondary" my={2}>
        {content
          .split(' ')
          .filter((word, index) => index < maxWords)
          .join(' ')}
        ...
      </Typography>

      <Button
        endIcon={<Iconify icon={directionStraightRight} />}
        sx={{
          justifyContent: 'flex-start',
          padding: 0,
          '&:hover': { backgroundColor: 'transparent' },
        }}
      >
        {readMore}
      </Button>
    </Box>
    /* </links> */
  );
};
